import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useTranslation } from '../../../i18n/use-translation';
import * as styles from './swich.module.sass';

export const Swicher = (props: any) => {
  const { t, locale, supportedLocales } = useTranslation();


  

  const pageName = window.location.pathname.split('/')[2]

  const switchers = useMemo(() => {
    return supportedLocales.map(supLoc => {
      return (
        <a
          href={`/${supLoc}/${pageName}`}
          key={supLoc}
          className={classNames(styles.swich_link, {
            [styles.active]: locale === supLoc,
          })}
        >
          {t(supLoc)}
        </a>
      );
    });
  }, [locale]);

  return (
    <div
      className={classNames(styles.switcher, {
        [styles.mobile_display]: props.mobile_display,
      })}
    >
      {switchers}
    </div>
  );
};
